var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4882 4.20832C15.7274 2.7192 15.4695 1.17328 15.4695 1.17328C15.4695 1.17328 13.7351 1.18128 12.4876 2.8256C11.3783 4.28768 11.6607 5.53824 11.6607 5.53824C11.6607 5.53824 13.1648 5.7984 14.4882 4.20832Z",
    fill: "#232429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8678 11.2352C16.8678 8.68785 18.9213 7.63793 18.9213 7.63793C18.9213 7.63793 17.8713 5.73889 15.2027 5.73889C13.6523 5.73889 12.4613 6.62113 11.8195 6.62113C11.0718 6.62113 9.95599 5.79185 8.51791 5.79185C6.30591 5.79185 3.94751 7.77249 3.94751 11.5482C3.94719 15.3858 6.73359 20.16 8.93903 20.16C9.70879 20.16 10.8909 19.3845 12.0819 19.3845C13.2507 19.3845 14.1131 20.132 15.2224 20.132C17.6376 20.132 19.4256 15.0991 19.4256 15.0991C19.4256 15.0991 16.8678 14.1088 16.8678 11.2352Z",
    fill: "#232429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple2);
export default __webpack_public_path__ + "static/media/apple2.9cdbb73194500514f130123cfa9aefb2.svg";
export { ForwardRef as ReactComponent };